import React from "react";

const PriceCard = ({ course, handleAddOpen }) => {
  return (
    <div className="sticky top-24">
      <div className="bg-white/5 border border-white/10 backdrop-blur-md p-5 sm:p-6 rounded-3xl shadow-2xl space-y-4">
        <h3 className="text-base sm:text-lg font-semibold leading-snug text-white">
          {course.title}
        </h3>

        <div className="flex items-baseline gap-2">
          <span className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-[#64a2ff] to-[#064585] bg-clip-text text-transparent">
            {course.price}
          </span>
          <span className="text-xs sm:text-sm line-through text-slate-400">
            {course.oldPrice}
          </span>
        </div>

        <p className="text-xs sm:text-sm text-slate-200/90">
          Get lifetime access to all lessons, projects, and resources.
        </p>

        <button
          className="w-full inline-flex items-center justify-center rounded-full bg-[#064585] px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#064585]/40 hover:bg-[#033465] transition-all duration-200 hover:-translate-y-0.5"
          onClick={handleAddOpen}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default PriceCard;
